<script setup lang="ts">
import icons from '@/assets/icons'
import { includes, keys } from 'lodash'
import * as Phosphor from '@phosphor-icons/vue'
import InlineSvg from 'vue-inline-svg'
import type { Icons } from '@/types/icons'

const iconKeys = keys(icons)
const phosphorKeys = keys(Phosphor)

const props = defineProps<{
    icon: string
}>()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let component: any
let src: Icons | undefined
switch (true) {
    case includes(iconKeys, props.icon):
        component = InlineSvg
        src = icons[props.icon]
        break
    case includes(phosphorKeys, props.icon):
        // @ts-expect-error implicit-any
        component = Phosphor[props.icon]
        break
}
</script>

<template>
    <component
        v-if="component"
        :is="component"
        :src />
</template>
